import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";
import {MockupType} from "./mockup-type.enum";
import {MockupDataModel} from "./mockup-data.model";
import {ASSETS_SVG} from "../constants/path.constants";

@Component({
  selector: 'app-qr-copy-message',
  templateUrl: './qr-copy.component.html',
  styleUrl: './qr-copy.component.scss'
})
export class QrCopyMessageComponent {

  private readonly SUCCESS_SVG_NAME = 'mockup-success.svg';
  private readonly ERROR_SVG_NAME = 'mockup-error.svg';
  private readonly INFO_SVG_NAME = 'mockup-info.svg';

  protected message: string;
  protected type: MockupType;

  constructor(@Inject(MAT_SNACK_BAR_DATA) data: MockupDataModel) {
    this.message = data.message ? data.message : '';
    this.type = data.type ? data.type : MockupType.SUCCESS;
  }

  protected getIconPathByType(type: MockupType) {
    switch (type) {
      case MockupType.SUCCESS:
        return ASSETS_SVG + this.SUCCESS_SVG_NAME;
      case MockupType.ERROR:
        return ASSETS_SVG + this.ERROR_SVG_NAME;
      case MockupType.INFO:
        return ASSETS_SVG + this.INFO_SVG_NAME;
    }
  }
}
